import {
  REQUEST_MLD_HOME_SEARCH,
	RESPONSE_MLD_HOME_SEARCH,
	FAILURE_MLD_HOME_SEARCH,
	UPDATE_MLD_HOME_SEARCH_FILTER,
	MLD_HOME_PROFESSIONALS_UPDATE_FILTER,
	TOGGLE_MLD_HOME_SAVE_MODE,
	UPDATE_MLD_HOME_SAVE_LIST_ITEMS,
	UPDATE_MLD_HOME_SAVE_LIST_TYPE,
	UPDATE_MLD_HOME_COLUMNS,
	UPDATE_MLD_HOME_CHECKBOX_FILTERS,
	UPDATE_MLD_HOME_MULTI_SORT
} from "../../actions/types";

import { defaultFilters } from "./constants";
// import { defaultTerms } from "../../../_components/zognix/WasExperts/_constants";

// let defaultTermsArr = Object.keys(defaultTerms);
// let defaultmldHomeArr = {};
// for (let each of defaultTermsArr) {
//   each = each.toUpperCase();
//   let heading = `${each}`;
//   defaultmldHomeArr = {
//     ...defaultmldHomeArr,
//     [heading]: false
//   };
// }

const initialState = {
  multiSort: {},
  isInitialScreen: true,
  isFetching: false,
  results: [],
  error: false,
  activePage: 1,
  multiSort: {},
  filters: defaultFilters,
  keyword: "",
  total: 0,
  isSaveActive: false,
  selectedItems: {},
  saveListType: "",

  totalArticles: 0,
  totalTrials: 0,
  advExperts: 0,
  total5YExperts: 0,
  totalCountries: 0,
  mldHomeArr: {
    DETAILS: {
      "EMAIL": true,
      "PHONE NUMBER": true
    },
    TOPIC: {
      "METACHROMATIC LEUKODYSTROPHY": true,
      "WISKOTT-ALDRICH SYNDROME": true,
      "NEWBORN AND DIAGNOSTIC SCREENING": true
    }
  },
  criteria: {
    high: ["contact_details"],
    medium: [
      "is_mld_shortlist",
      "is_was_shortlist",
      "is_newborn_shortlist"
    ],
    low: []
  }
};

const setCriteria = (state, action) => {
  // console.log('setCriter is executed!')
  let criteria = action.payload || {};
  // let key = changedParams.key;
  // let value = changedParams.value;
  // let availbleWeights = ["hight", "medium", "low"];
  // availbleWeights = availbleWeights.filter(l => l !== key);
  // let criteria = {
  //   ...state.criteria
  // }
  // criteria[key] = [... new Set([...criteria[key], value])]
  // availbleWeights.forEach(l => {
  //   criteria[l] = [... new Set([...criteria[l].filter(k => k !== value)])]
  // });

  return {
    ...state,
    criteria
  }
}

const setRequest = (state, action) => {
  let { keyword, filters, activePage } = action.payload;
  if (!filters) {
    filters = {
      year: "",
      country: [],
      partner: "false"
    };
  }

  return {
    ...state,
    isFetching: true,
    error: false,
    isInitialScreen: false,
    results: [],
    keyword: keyword,
    filters,
    activePage,
    totalArticles: 0,
    total: 0,
    totalTrials: 0,
    advExperts: 0,
    total5YExperts: 0,
    totalCountries: 0
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    isInitialScreen: false,
    results: []
  };
};

const setResponse = (state, action) => {
  let {
    results = [],
    totalArticles,
    total,
    totalCountries,
    totalTrials,
    advExperts,
    total5YExperts
  } = action.payload;

  return {
    ...state,
    isFetching: false,
    error: false,
    results: results,
    isInitialScreen: false,
    totalArticles,
    total,
    total5YExperts,
    advExperts,
    totalCountries,
    totalTrials
  };
};

const setFilters = (state, action) => {
  let filters = action.payload.filters || defaultFilters;
  return {
    ...state,
    filters: filters
  };
};

const handleSaveToggle = (state, action) => {
  return {
    ...state,
    isSaveActive: !state.isSaveActive,
    selectedItems: {},
    saveListType: ""
  };
};

const handleUpdateSaveListItems = (state, action) => {
  let selectedItems = action.payload.selectedItems || {};
  return {
    ...state,
    selectedItems: selectedItems
  };
};

const updateSaveListType = (state, action) => {
  let saveListType = action.payload.saveListType;
  return {
    ...state,
    saveListType: saveListType
  };
};

const updateColumnState = (state, action) => {
  let { mldHomeArr } = action.payload;

  return {
    ...state,
    mldHomeArr
  };
};

const updateCheckboxFilters = (state, action) => {
  let { checkboxItemList } = action.payload;

  return {
    ...state,
    checkboxItemList
  };
};


const updateFilter = (state, action) => {
  let { filters } = action.payload;
  filters = filters || {};
  let { country, experts, listType, terms, year, university } = filters;

  let newFilters = {};
  if (country) {
    country = country || "";
    country = country
      .split(",")
      .filter(l => l)
      .map(l => ({
        label: l,
        value: l
      }));
    newFilters.location = country;
  }

  if (listType) {
    if (listType === "yes") {
      listType = "SHORT LIST";
      listType = {
        label: listType,
        value: "SHORT_LIST"
      };
    } else if (listType === "final") {
      listType = "FINAL LIST";
      listType = {
        label: listType,
        value: "FINAL_LIST"
      };
    } else if (listType === "no") {
      listType = "LONG LIST";
      listType = {
        label: listType,
        value: "LONG_LIST"
      };
    } else if (listType === "personal") {
      listType = "PERSONAL LIST";
      listType = {
        label: listType,
        value: "PERSONAL_LIST"
      };
    } else {
      listType = "LONG LIST";
      listType = {
        label: listType,
        value: "LONG_LIST"
      };
    }

    newFilters.listType = listType;
  }

  if (experts) {
    newFilters.experts = experts;
  }

  if (university) {
    newFilters.affs = university;
  }

  if (terms) {
    terms = terms || "";
    terms = terms
      .split(",")
      .filter(l => l)
      .map(l => ({
        label: l,
        value: l
      }));
    newFilters.topic = terms;
  }

  if (year) {
    newFilters.year = {
      label: year,
      value: year
    };
  }

  newFilters = {
    ...defaultFilters,
    ...newFilters
  };
  return {
    ...state,
    activePage: 1,
    filters: newFilters,
    from: 0
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RESPONSE_MLD_HOME_SEARCH:
      return setResponse(state, action);
      break;

    case FAILURE_MLD_HOME_SEARCH:
      return setFailure(state, action);
      break;

    case REQUEST_MLD_HOME_SEARCH:
      return setRequest(state, action);

    case UPDATE_MLD_HOME_SEARCH_FILTER:
      return setFilters(state, action);

    case TOGGLE_MLD_HOME_SAVE_MODE:
      return handleSaveToggle(state, action);

    case UPDATE_MLD_HOME_SAVE_LIST_ITEMS:
      return handleUpdateSaveListItems(state, action);

    case UPDATE_MLD_HOME_SAVE_LIST_TYPE:
      return updateSaveListType(state, action);

    case MLD_HOME_PROFESSIONALS_UPDATE_FILTER:
      return updateFilter(state, action);

    case UPDATE_MLD_HOME_COLUMNS:
      return updateColumnState(state, action);

    case UPDATE_MLD_HOME_CHECKBOX_FILTERS:
      return updateCheckboxFilters(state, action);
    
    case UPDATE_MLD_HOME_MULTI_SORT:
      return setCriteria(state, action);
    
    default:
      return state;
      break;
  }
};
